export default __webpack_public_path__ + "static/media/bell-on.f3ff703b.svg";